import Vue from 'vue'
import Vuex from 'vuex'

/*
  return
   - vue intance를 식별하기 위한 unique id
*/
const getName = () => {
  return 'pageInfo'
}

/*
   return
    - localstore 저장용 vue instance
*/
const createInstance = () => {
  let localStore = ''

  if (window.vue.getStore(getName) === undefined) {
    const store = new Vuex.Store({
      state: {
        // 해당페이지의 Tab List 정의용
        pageInfo: {
          title: '',
          menuIdx: 0,
          mode: '',
          tabIdx: 0,
          subTitle: '',
          target: ''
        },
        // HistoryInfo 설정여부
        isHistoryInfo: false,
        // 해당페이지의 Tab List 페이지 > Tab List 페이지 이동시 history 정의용
        historyInfo: {
          title: '',
          menuIdx: 0,
          mode: '',
          tabIdx: 0,
          subTitle: '',
          target: '',
          searchData: undefined
        }
      },
      getters: {
        // pageInfo
        getPageInfo: state => {
          return state.pageInfo
        },
        getMenuIdx: state => {
          return state.pageInfo.menuIdx
        },
        getTitle: state => {
          return state.pageInfo.title
        },
        getMode: state => {
          return state.pageInfo.mode
        },
        getTabIdx: state => {
          return state.pageInfo.tabIdx
        },
        getSubTitle: state => {
          return state.pageInfo.subTitle
        },
        getTarget: state => {
          return state.pageInfo.target
        },
        // isHistoryInfo
        getIsHistoryInfo: state => {
          return state.isHistoryInfo
        },
        // historyInfo
        getHistoryInfo: state => {
          return state.historyInfo
        },
        getHistoryMenuIdx: state => {
          return state.historyInfo.menuIdx
        },
        getHistoryTitle: state => {
          return state.historyInfo.title
        },
        getHistoryMode: state => {
          return state.historyInfo.mode
        },
        getHistoryTabIdx: state => {
          return state.historyInfo.tabIdx
        },
        getHistorySubTitle: state => {
          return state.historyInfo.subTitle
        },
        getHistoryTarget: state => {
          return state.historyInfo.target
        },
        getHistorySearchData: state => {
          return state.historyInfo.searchData
        }
      },
      mutations: {
        REGISTER_PAGE_INFO (state, obj) {
          state.pageInfo = obj
        },
        UPDATE_PAGE_INFO (state, obj) {
          if ( obj.title && typeof obj.title !== 'undefined' ) {
            state.pageInfo.title = obj.title
          }
          if ( obj.menuIdx !== null && typeof obj.menuIdx !== 'undefined' ) {
            state.pageInfo.menuIdx = obj.menuIdx
          }
          if ( obj.mode && typeof obj.mode !== 'undefined' ) {
            state.pageInfo.mode = obj.mode
          }
          if ( obj.tabIdx !== null && typeof obj.tabIdx !== 'undefined' ) {
            state.pageInfo.tabIdx = obj.tabIdx
          }
          if ( obj.subTitle && typeof obj.subTitle !== 'undefined' ) {
            state.pageInfo.subTitle = obj.subTitle
          }
          if ( obj.target && typeof obj.target !== 'undefined' ) {
            state.pageInfo.target = obj.target
          }
        },
        UPDATE_PAGE_INFO_MENUIDX (state, menuIdx) {
          state.pageInfo.menuIdx = menuIdx
        },
        UPDATE_PAGE_INFO_TITLE (state, title) {
          state.pageInfo.title = title
        },
        UPDATE_PAGE_INFO_MODE (state, mode) {
          state.pageInfo.mode = mode
        },
        UPDATE_PAGE_INFO_TABIDX (state, tabIdx) {
          state.pageInfo.tabIdx = tabIdx
        },
        UPDATE_PAGE_INFO_SUBTITLE (state, subTitle) {
          state.pageInfo.subTitle = subTitle
        },
        UPDATE_PAGE_INFO_TARGET (state, target) {
          state.pageInfo.target = target
        },
        DELETE_PAGE_INFO (state) {
          state.pageInfo = {
            menuIdx: 0,
            title: '',
            mode: '',
            tabIdx: 0,
            subTitle: '',
            target: ''
          }
        },
        UPDATE_IS_HISTORY_INFO (state, isVal) {
          state.isHistoryInfo = isVal
        },
        REGISTER_HISTORY_INFO (state, obj) {
          state.historyInfo = obj
        },
        UPDATE_HISTORY_INFO (state, obj) {
          if ( obj.menuIdx !== null && typeof obj.menuIdx !== 'undefined' ) {
            state.historyInfo.menuIdx = obj.menuIdx
          }
          if ( obj.title && typeof obj.title !== 'undefined' ) {
            state.historyInfo.title = obj.title
          }
          if ( obj.mode && typeof obj.mode !== 'undefined' ) {
            state.historyInfo.mode = obj.mode
          }
          if ( obj.tabIdx !== null && typeof obj.tabIdx !== 'undefined' ) {
            state.historyInfo.tabIdx = obj.tabIdx
          }
          if ( obj.subTitle && typeof obj.subTitle !== 'undefined' ) {
            state.historyInfo.subTitle = obj.subTitle
          }
          if ( obj.target && typeof obj.target !== 'undefined' ) {
            state.historyInfo.target = obj.target
          }
          if ( obj.searchData && typeof obj.searchData !== 'undefined' ) {
            state.historyInfo.searchData = obj.searchData
          }
        },
        UPDATE_HISTORY_INFO_MENUIDX (state, menuIdx) {
          state.historyInfo.menuIdx = menuIdx
        },
        UPDATE_HISTORY_INFO_TITLE (state, title) {
          state.historyInfo.title = title
        },
        UPDATE_HISTORY_INFO_MODE (state, mode) {
          state.historyInfo.mode = mode
        },
        UPDATE_HISTORY_INFO_TABIDX (state, tabIdx) {
          state.historyInfo.tabIdx = tabIdx
        },
        UPDATE_HISTORY_INFO_SUBTITLE (state, subTitle) {
          state.historyInfo.subTitle = subTitle
        },
        UPDATE_HISTORY_INFO_TARGET (state, target) {
          state.historyInfo.target = target
        },
        UPDATE_HISTORY_INFO_SEARCH_DATA (state, target) {
          state.historyInfo.searchData = target
        },
        DELETE_HISTORY_INFO (state) {
          state.isHistoryInfo = false
          state.historyInfo = {
            menuIdx: 0,
            title: '',
            mode: '',
            tabIdx: 0,
            subTitle: '',
            target: '',
            searchData: undefined
          }
        }
      },
      actions: {
        REGISTER_PAGE_INFO ({commit}, {obj}) {
          return commit('REGISTER_PAGE_INFO', obj)
        },
        UPDATE_PAGE_INFO ({commit}, obj) {
          return commit('UPDATE_PAGE_INFO', obj)
        },
        UPDATE_PAGE_INFO_MENUIDX ({commit}, menuIdx) {
          return commit('UPDATE_PAGE_INFO_MENUIDX', menuIdx)
        },
        UPDATE_PAGE_INFO_TITLE ({commit}, title) {
          return commit('UPDATE_PAGE_INFO_TITLE', title)
        },
        UPDATE_PAGE_INFO_MODE ({commit}, mode) {
          return commit('UPDATE_PAGE_INFO_MODE', mode)
        },
        UPDATE_PAGE_INFO_TABIDX ({commit}, tabIdx) {
          return commit('UPDATE_PAGE_INFO_TABIDX', tabIdx)
        },
        UPDATE_PAGE_INFO_SUBTITLE ({commit}, subTitle) {
          return commit('UPDATE_PAGE_INFO_SUBTITLE', subTitle)
        },
        UPDATE_PAGE_INFO_TARGET ({commit}, target) {
          return commit('UPDATE_PAGE_INFO_TARGET', target)
        },
        DELETE_PAGE_INFO ({commit}) {
          commit('DELETE_PAGE_INFO')
        },
        UPDATE_IS_HISTORY_INFO ({commit}, val) {
          return commit('UPDATE_IS_HISTORY_INFO', val)
        },
        REGISTER_HISTORY_INFO ({commit}, {obj}) {
          return commit('REGISTER_HISTORY_INFO', obj)
        },
        UPDATE_HISTORY_INFO ({commit}, obj) {
          return commit('UPDATE_HISTORY_INFO', obj)
        },
        UPDATE_HISTORY_INFO_MENUIDX ({commit}, menuIdx) {
          return commit('UPDATE_HISTORY_INFO_MENUIDX', menuIdx)
        },
        UPDATE_HISTORY_INFO_TITLE ({commit}, title) {
          return commit('UPDATE_HISTORY_INFO_TITLE', title)
        },
        UPDATE_HISTORY_INFO_MODE ({commit}, mode) {
          return commit('UPDATE_HISTORY_INFO_MODE', mode)
        },
        UPDATE_HISTORY_INFO_TABIDX ({commit}, tabIdx) {
          return commit('UPDATE_HISTORY_INFO_TABIDX', tabIdx)
        },
        UPDATE_HISTORY_INFO_SUBTITLE ({commit}, subTitle) {
          return commit('UPDATE_HISTORY_INFO_SUBTITLE', subTitle)
        },
        UPDATE_HISTORY_INFO_TARGET ({commit}, target) {
          return commit('UPDATE_HISTORY_INFO_TARGET', target)
        },
        UPDATE_HISTORY_INFO_SEARCH_DATA ({commit}, target) {
          return commit('UPDATE_HISTORY_INFO_SEARCH_DATA', target)
        },
        DELETE_HISTORY_INFO ({commit}) {
          commit('DELETE_HISTORY_INFO')
        }
      }
    })

    // local vuex 용 vue instance 추가
    localStore = new Vue({
      store: store
    })
  }

  return localStore
}

var store = {}
store.getName = getName
store.createInstance = createInstance

export default store



// WEBPACK FOOTER //
// ./src/config/vuex/pageInfo.js